import { useContext } from "react";
import { PaymentMethodContext } from "./PaymentMethodProvider";

export default function usePaymentMethodContext() {
    return useContext(PaymentMethodContext);
};
